import { useUser } from "~/lib/utils/user";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { getUserImgSrc } from "~/lib/utils/misc";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Form, useRouteLoaderData, useSubmit } from "react-router";
import { TenantLink } from "~/components/tenant-link";
import { Icon } from "../ui/icon";
import { useRef } from "react";
import { Separator } from "../ui/separator";
import { useHydrated } from "remix-utils/use-hydrated";
import { User } from "~/lib/db/schema";
import { loader as rootLoader } from "~/root";

export const UserAvatar = ({
  src,
  alt,
  className,
  user,
}: {
  src?: string;
  alt?: string;
  className?: string;
  user?: Pick<User, "image" | "profile">;
}) => {
  const myUser = useUser();
  const isHydrated = useHydrated();

  const image =
    user && !user.image
      ? undefined
      : user && user.image
        ? user.image
        : myUser.image;
  const profile = user?.profile || myUser.profile;

  return (
    <Avatar className={className || "w-8 h-8 shadow-md"}>
      <AvatarImage
        src={src || getUserImgSrc(image?.id)}
        alt={alt || `${profile?.name}'s profile picture`}
        className="object-cover"
      />
      {isHydrated ? (
        <AvatarFallback
          style={{
            background: profile?.fallbackGradient,
          }}
        />
      ) : (
        <AvatarFallback className="bg-card-foreground/10 animate-pulse" />
      )}
    </Avatar>
  );
};

export const UserDropdown = () => {
  const data = useRouteLoaderData<typeof rootLoader>("root");

  const submit = useSubmit();
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          // this is for progressive enhancement
          onClick={(e) => e.preventDefault()}
          className="rounded-full outline-offset-2"
        >
          <UserAvatar />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent sideOffset={8} align="end">
          {/* <DropdownMenuItem asChild>
						<TenantLink prefetch="intent" to={`/users/${user.username}`}>
							<Icon className="text-body-md" name="avatar">
								Profile
							</Icon>
						</TenantLink>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<TenantLink prefetch="intent" to={`/users/${user.username}/notes`}>
							<Icon className="text-body-md" name="pencil-2">
								Notes
							</Icon>
						</TenantLink>
					</DropdownMenuItem> */}
          {data?.team && (
            <>
              <DropdownMenuItem asChild className="cursor-pointer">
                <TenantLink prefetch="intent" to="/settings/general">
                  <Icon className="text-body-md" name="settings">
                    Ajustes
                  </Icon>
                </TenantLink>
              </DropdownMenuItem>
              <Separator className="my-1" />
            </>
          )}

          <DropdownMenuItem
            asChild
            // this prevents the menu from closing before the form submission is completed
            onSelect={(event) => {
              event.preventDefault();
              submit(formRef.current);
            }}
            className="cursor-pointer"
          >
            <Form action="/logout" method="POST" ref={formRef}>
              <Icon className="text-body-md" name="exit">
                <button type="submit">Cierra sesión</button>
              </Icon>
            </Form>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
};
